import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@telespot/shared/environment';

import { AppModule } from './app/app.module';

if (environment.production) enableProdMode();

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    preserveWhitespaces: true,
  })
  .catch((err) => console.error('[Telespot] Error during bootstrap', err));
